import { atom } from 'jotai'
import { RESET } from 'jotai/utils'

export const resettableAtomWithStorage = <T>(key: string, defaultValue: T) => {
	const baseAtom = atom(defaultValue)

	return atom(
		(get) => get(baseAtom),
		(_, set, update: T | typeof RESET) => {
			if (update === RESET) {
				set(baseAtom, defaultValue)
			} else {
				set(baseAtom, update)
			}
		},
	)
}
